<!--MIS CURSOS -->

<section *ngIf="hasError" class="error-state">
  <h2>Error 404</h2>
  <p>El contenido que buscas no está disponible.</p>
</section>

<ng-container *ngIf="!hasError">
  <!--========== NEW BANNER FILTER========-->
  <section class="mx-4 mt-12 pt-2 md:pt-0 md:mt-0 px-1 md:max-w-7xl md:mx-auto">
    <div class="flex flex-col md:flex-row gap-4 md:gap-6 pt-6 md:pt-10 pb-6">
      <div class="flex-shrink-0 overflow-hidden transition-all duration-300 flex  items-center"
        [style.width]="sidebarCollapsed ? '50px' : '220px'">
        <!-- Collapsed: icono badge -->
        <div *ngIf="sidebarCollapsed"
          class="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="text-gray-500">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
        </div>
        <!-- Expanded: título completo -->
        <a *ngIf="!sidebarCollapsed" class="text-xl md:text-2xl font-semibold text-gray-700 whitespace-nowrap">
          {{"words.my-courses" | translate}}
        </a>
      </div>
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <msc-shared-search-sort-bar [mode]="mode" [query]="query" [type]="'content'"
          [statusOptions]="topbarFilters.statusOptions"
          [activeRanking]="activeRanking"
          [activeSaved]="activeSaved"
          (queryChange)="search($event)"
          (filtersChange)="onSortChange($event)"
          (statusChange)="topbarFilters.selectStatusByValue($event)"
          (viewModeChange)="onViewModeChange($event)"
          (rankingChange)="onRankingChange($event)"
          (savedChange)="onSavedChange($event)"
          (mobileFiltersClick)="topbarFilters.openMobileDrawer()">
        </msc-shared-search-sort-bar>
      </div>
    </div>
  </section>

  <!-- SECTION MIS CURSOS -->
  <section class="w-full">
    <section class="section-content relative mx-auto max-w-7xl  pb-14 lg:pb-20">

      <!--DIV LIST - VIEW -->
      <div class="px-4 md:px-0 md:flex gap-6">
        <!--filtros mis cursos-->
        <msc-shared-topbar-filters #topbarFilters [type]="'content'" [(query)]="query" [(mode)]="mode"
          [(filters)]="filters" [(activeFilters)]="activeFilters" [statusCounts]="statusCounts"
          (queryChange)="search()" (filtersChange)="search()"
          (collapsedChange)="sidebarCollapsed = $event">
        </msc-shared-topbar-filters>

        <!--grid cards mis cursos-->
        <div class="flex-1 min-w-0 flex flex-col">

          <!-- ===== ACTIVE FILTER PILLS ===== -->
          <div *ngIf="filters?.contentTypes?.length > 0 || filters?.contentSkills?.length > 0 || filters?.providers?.length > 0 || filters?.langs?.length > 0"
            class="flex flex-wrap gap-1.5 mb-3 pt-1">

            <!-- Tipos de contenido (external_content se oculta: queda fusionado con Cursos) -->
            <ng-container *ngFor="let type of topbarFilters.availableTypes">
              <button *ngIf="type.isSelected && type.value !== 'external_content'" type="button"
                class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-medium bg-secondary-100 text-secondary-700 transition-colors cursor-pointer hover:opacity-80"
                (click)="topbarFilters.onSelectType(type)">
                {{ type.label }}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                </svg>
              </button>
            </ng-container>

            <!-- Áreas de conocimiento - OCULTO EN MIS CURSOS -->
            <!-- <ng-container *ngFor="let skill of topbarFilters.availableSkills">
              <button *ngIf="skill.isSelected" type="button"
                class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-medium bg-secondary-100 text-secondary-700 transition-colors cursor-pointer hover:opacity-80"
                (click)="topbarFilters.onInlineMultiselectChange(skill, 'contentSkills', topbarFilters.availableSkills)">
                {{ skill.label }}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                </svg>
              </button>
            </ng-container> -->

            <!-- Proveedores -->
            <ng-container *ngFor="let provider of topbarFilters.availableProviders">
              <button *ngIf="provider.isChecked" type="button"
                class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-medium bg-secondary-100 text-[#A32D2D] transition-colors cursor-pointer hover:opacity-80"
                (click)="topbarFilters.onInlineMultiselectChange(provider, 'providers', topbarFilters.availableProviders)">
                {{ provider.label }}
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                </svg>
              </button>
            </ng-container>

            <!-- Idiomas -->
            <ng-container *ngFor="let filter of topbarFilters.filtersModal">
              <ng-container *ngIf="filter.name === 'langs'">
                <ng-container *ngFor="let option of filter.options">
                  <button *ngIf="option.isSelected" type="button"
                    class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[12px] font-medium bg-secondary-100 text-[#A32D2D] transition-colors cursor-pointer hover:opacity-80"
                    (click)="topbarFilters.onInlineMultiselectChange(option, 'langs', filter.options)">
                    {{ option.label }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                    </svg>
                  </button>
                </ng-container>
              </ng-container>
            </ng-container>

          </div>

          <!-- CURSOS - List mode -->
          <div *ngIf="mode === 'list'" class="min-h-screen pb-10 flex flex-col" infinite-scroll [scrollWindow]="true"
            [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="loadMore()"
            [infiniteScrollDisabled]="loading || loadingFilter || !contents?.length">

            <!-- Estado de carga único para filtros de progreso y ranking -->
            <div *ngIf="loadingFilter" class="flex flex-col items-center justify-center py-16 gap-3">
              <div class="w-8 h-8 border-[3px] border-secondary-500 border-t-transparent rounded-full animate-spin"></div>
              <p class="text-[14px] font-medium text-gray-600">{{'words.applying-filter' | translate}}</p>
              <p class="text-xs text-gray-400">{{'words.loading-all-courses' | translate}}</p>
            </div>

            <ng-container *ngIf="!loadingFilter">
              <section class="card-course-grid flex-grow w-full" *ngIf="contents?.length > 0">
                <!-- Grid view -->
                <div *ngIf="viewMode === 'grid'"
                  class="grid-catalogue grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-5 mb-8">
                  <ng-container *ngFor="let content of contents; let index = index">
                    <div class="relative" [ngClass]="{'custom-width-card': contents.length <= 2}">
                      <content-card id="card-catalogue" [content]="content" [compact]="true"
                        (onDelete)="$event ? '' : deleteContent(index)" [origin]="activeSaved ? 'savedContent' : 'subscribed'">
                      </content-card>
                    </div>
                  </ng-container>
                </div>
                <!-- List view -->
                <div *ngIf="viewMode === 'list'" class="flex flex-col gap-3 mb-8">
                  <ng-container *ngFor="let content of contents; let index = index">
                    <content-card-list [content]="content"
                      (onDelete)="$event ? '' : deleteContent(index)" [origin]="activeSaved ? 'savedContent' : 'subscribed'">
                    </content-card-list>
                  </ng-container>
                </div>
              </section>

              <!-- Empty state búsqueda normal -->
              <msc-empty-state *ngIf="!searching && contents?.length === 0 && !activeRanking"
                [title]="'empty.content.search.title'"
                [description]="'empty.content.search.description'" [cypressHook]="'contents'">
              </msc-empty-state>

              <!-- Empty state filtro de ranking -->
              <div *ngIf="!searching && contents?.length === 0 && activeRanking"
                class="flex flex-col items-center justify-center py-16 text-center gap-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-300">
                  <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                  <path d="M4 22h16"></path><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                  <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                  <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                </svg>
               <p class="text-[15px] font-semibold text-gray-600">
                  <ng-container *ngIf="activeRanking === 'top'">{{'words.no-courses-available' | translate}}</ng-container>
                  <ng-container *ngIf="activeRanking === 'lowest'">{{'words.no-courses-with-rating' | translate}}</ng-container>
                  <ng-container *ngIf="activeRanking === 'unrated'">{{'words.all-courses-rated' | translate}}</ng-container>
                </p>
                <p class="text-[13px] text-gray-400"> {{'words.try-another-ranking-filter' | translate}}</p>
              </div>

              <!-- Loading indicator paginación normal -->
              <div *ngIf="loading && !loadingFilter && contents?.length > 0 && (pagination?.currentPage < pagination?.lastPage)" class="flex justify-center py-8">
                <div class="flex items-center gap-2">
                  <div class="w-2 h-2 bg-secondary-500 rounded-full animate-pulse"></div>
                  <p class="text-sm text-muted-foreground">{{'words.loading-more-courses' | translate}}</p>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- CURSOS - Calendar mode -->
          <section *ngIf="mode === 'calendar'" class="body" infinite-scroll [scrollWindow]="false"
            [infiniteScrollDistance]="2" [infiniteScrollThrottle]="500" (scrolled)="loadMoreEvents()"
            infiniteScrollTrigger [items]="events">
            <div class="container-contents__list row animate" *ngIf="!searching">
              <msc-shared-event-calendar [type]="'content'" [events]="events"></msc-shared-event-calendar>

              <msc-empty-state *ngIf="events?.length === 0" [title]="'empty.content.search.title'"
                [description]="'empty.content.search.description'" [cypressHook]="'calendar'">
              </msc-empty-state>
            </div>
            <div class="container-catalog-internal__list row animate">
              <msc-shared-event-calendar [type]="'catalogue'" [events]="events"></msc-shared-event-calendar>
            </div>
          </section>

        </div>
      </div>

    </section>
  </section>
</ng-container>

<!--
  [SCROLL-TO-TOP] Botón flotante para volver al tope de la página.
  - Aparece tras 300px de scroll (controlado por showScrollTop en el .ts).
  - La clase .no-chat se añade dinámicamente cuando el floating-chat IA
    no está habilitado (companyAiAssistant !== true), bajando el botón
    a bottom: 24px para ocupar el espacio libre de la esquina inferior derecha.
-->
<button
  *ngIf="showScrollTop"
  (click)="scrollToTop()"
  [class.no-chat]="!isChatEnabled"
  class="scroll-to-top-btn"
  aria-label="Volver arriba"
  title="Volver arriba">
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
</button>
